import {useContext} from 'react';
import PopupContext from './PopupContext';
import {HIDE_POPUP, SHOW_POPUP} from "./Reducer";
import {useDispatch} from "react-redux";
import {closePopup} from "../jsonScreen.slice";


function usePopup() {
    const [popupState, dispatch] = useContext(PopupContext);
    const dispatchRedux = useDispatch();
    const popup = popupParams => {
        dispatch({
            type: SHOW_POPUP,
            payload: popupParams
        });
    };

    const onClosePopup = async (selfClose, name) => {
        dispatch({
            type: HIDE_POPUP,
            payload: {name},
        });
        dispatchRedux(closePopup({name}))
        if (!selfClose && popupState.popups[name]?.onCloseActions) {
            popupState.popups[name].onCloseActions();
        }
    };

    return {popup, closePopup: onClosePopup, popupState};
}

export default usePopup;